import { ReviewInterface } from "@swivl-mono/types";
import { Checkbox } from "@swivl-mono/ui";
import { AiFillStar } from "react-icons/ai";
import { FaGoogle } from "react-icons/fa";

import ReviewsModel from "../../../Models/Reviews/Reviews.Model";
import { isReviewDeletedOnGoogle } from "../Helpers/ReviewsViewHelper";
import { ReviewViewHeader } from "./Components/Review.View.Header";
import { ReviewViewReply } from "./Components/Review.View.Reply";
import "./Review.View.scss";

interface Props {
  review: ReviewInterface;

  selected: boolean;
  showingMultiSelect: boolean;
  // setSelectionOnReview: (review: ReviewInterface, selected: boolean) => void;
}
export function ReviewView(props: Props) {
  const { review, selected, showingMultiSelect } = props;

  return (
    <div className="ReviewView">
      <div className="left">
        <Checkbox
          name={String(review.id)}
          checked={selected}
          disabled={isReviewDeletedOnGoogle(review)}
          onCheckedChange={(checked) => {
            ReviewsModel.setSelectOnReview(review, Boolean(checked));
          }}
        />
      </div>
      <div className="content">
        <ReviewViewHeader review={review} />
        <div className="reviewText">{review.text}</div>
        {showingMultiSelect ? null : (
          <div className="reviewReply">
            <ReviewViewReply review={review} />
          </div>
        )}
      </div>
    </div>
  );
}
